"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateDroppedFiles = void 0;

var _imageValidation = require("./image-validation");

// distinguish dropped files or dropped links
// for dropped links we can check if its google and get the images, map properties and send them along
// for dropped files we map properties and send them along
var mapUploadProperties = function mapUploadProperties(file, validations) {
  var validation = (0, _imageValidation.ImageValidationSync)(file, validations);
  var returnObject = {
    url: null,
    file: file,
    index: Math.random().toString(36).substr(2, 9),
    skip: 'errors' in validation,
    errors: []
  };

  if ('errors' in validation) {
    returnObject.errors = validation.errors;
    returnObject.errorComponents = (0, _imageValidation.validationErrorsToTextComponent)(validation.errors);
  }

  return returnObject;
};

var validateDroppedFiles = function validateDroppedFiles(files) {
  var validations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['max_size', 'ext'];
  var newFiles = files.map(function (file) {
    return mapUploadProperties(file, validations);
  });
  return newFiles;
};

exports.validateDroppedFiles = validateDroppedFiles;